import {AnyAction} from 'redux';
import {each, isString, indexOf} from 'lodash';
import {FormOnSubmitHelpers} from 'components/hook-form/Formik';

export function action<T>(type: String, payload?: T, callbacks?: FormOnSubmitHelpers<any>) {
   return {
      type,
      payload,
      callbacks,
   };
}
export interface Action<Payload = any, Callbacks = FormOnSubmitHelpers<any>> extends AnyAction {
   type: string;
   payload?: Payload;
   callbacks?: Callbacks;
}

export const asyncType = <T extends string>(name: T) =>
   ({
      REQUEST: `${name}_REQUEST`,
      SUCCESS: `${name}_SUCCESS`,
      ERROR: `${name}_ERROR`,
      SAGA: `${name}_SAGA`,
      _FETCHING: `${name}_FETCHING`,
      _ERROR: `${name}_ERROR`,
   } as const);
export type AsyncType = ReturnType<typeof asyncType>;

export function handleAsyncActions<T>(
   _state: T,
   action: Action,
   types: any,
   options?: {exclude?: string[]}
) {
   let state = _state;

   if (options?.exclude && indexOf(options?.exclude, action.type) >= 0) {
      return state;
   }

   each(types, (type: string | AsyncType) => {
      if (isString(type)) return;

      if (action.type === type.REQUEST) {
         state = {
            ...state,
            isFetching: true,
            [type._FETCHING]: true,
            error: null,
         };
         return false;
      }

      if (action.type === type.ERROR) {
         state = {
            ...state,
            isFetching: false,
            [type._FETCHING]: false,
            error: action.payload,
            [type._ERROR]: action.payload,
         };
         return false;
      }

      if (action.type === type.SUCCESS) {
         state = {
            ...state,
            isFetching: false,
            [type._FETCHING]: false,
            error: null,
            [type._ERROR]: null,
         };
         return false;
      }
   });
   return state;
}
